import React from 'react';
import { FilterOutlined } from '@ant-design/icons';

interface SortableFilterOptions {
  sort?: string;
  order?: string | 'asc' | 'desc' | '';
}

interface SortIconProps {
  field: string;
  filters: SortableFilterOptions;
}

const SortIcon: React.FC<SortIconProps> = ({ field, filters }) => {
  if (filters.sort !== field) {
    return <FilterOutlined className="w-4 h-4 text-gray-400" />;
  }
  return (
    <FilterOutlined
      className={`w-4 h-4 ${filters.order === 'asc' ? 'rotate-180' : ''} text-gray-600`}
    />
  );
};

export default SortIcon;
